<template>
  <v-dialog
    v-model="dialogEditTicket"
    @click:outside="closeModal"
    max-width="400"
    scrollable
  >
    <v-card min-height="220">
      <v-card-title class="px-6 py-2">
        <span class="font-weight-bold">
          {{ $t("sales.affiliates_program_tickets") }}
        </span>
      </v-card-title>
      <v-card-text
        class="d-flex justify-center align-center overflow-visible py-4"
      >
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="tickets"
              :label="$t('sales.affiliates_program_tickets_field')"
              :placeholder="$t('sales.affiliates_program_tickets_placeholder')"
              :no-data-text="$t('sales.affiliates_program_tickets_no')"
              item-text="descricao"
              item-value="idproduto_variacao"
              :items="allTickets"
              :loading="eventsLoading"
              class="rounded-lg"
              compact
              outlined
              clearable
              multiple
              deletable-chips
              chips
              dense
            >
              <template v-slot:selection="{ item }">
                <v-chip
                  small
                  close
                  class="my-2"
                  @click:close="removeTicketItem(item)"
                >
                  {{
                    item.descricao_completa ||
                    getTranslatedText(item.descricao) ||
                    item.descricao
                  }}
                </v-chip>
              </template>
              <template v-slot:item="{ item }">
                {{
                  item.descricao_completa ||
                  getTranslatedText(item.descricao) ||
                  item.descricao
                }}
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :color="$config.dados.primary"
          @click="closeModal"
          class="rounded-xxl"
          outlined
          >{{ $t("sales.affiliates_program_cancel") }}</v-btn
        >
        <v-btn
          @click="handleSave"
          :color="$config.dados.primary"
          style="color: white"
          class="rounded-xxl"
          >{{ $t("sales.affiliates_program_save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { getTranslatedText } from "../../../utils";
export default {
  name: "DialogEditTicketAffiliate",
  data() {
    return {
      getTranslatedText,
      tickets: null,
    };
  },
  computed: {
    ...mapGetters([
      "allEvents",
      "dataProgram",
      "dialogEditTicket",
      "eventsLoading",
    ]),
    allTickets() {
      return this.allEvents?.variantes?.variacoes_produto
        ? this.allEvents.variantes?.variacoes_produto.filter(
            variation =>
              variation.status !== "ESGOTADO" &&
              variation.tipo !== "RECARGA" &&
              variation.tipo !== "PRODUTO"
          )
        : [];
    },
    programTickets() {
      return this.dataProgram.nidproduto_variacao.split(";");
    },
  },
  methods: {
    ...mapActions(["changeDialogEditTicket", "fethEventsByID"]),
    ...mapMutations(["toggleDialogEditTicket", "setEvents"]),
    closeModal() {
      this.toggleDialogEditTicket();
    },
    handleSave() {
      this.changeDialogEditTicket({
        idprograma: this.dataProgram.idprograma,
        variacoes: this.tickets,
      });
    },
    removeTicketItem(item) {
      this.tickets = this.tickets.filter(
        tickets => tickets !== item.idproduto_variacao
      );
    },
  },
  watch: {
    dataProgram() {
      this.fethEventsByID({ idproduto: this.dataProgram.idproduto });
      this.tickets = this.programTickets;
    },
  },
  destroyed() {
    this.setEvents([]);
  },
};
</script>
